<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Veiledning for papir og spesialpapir">
     Veiledning for papir og spesialpapir
    </a>
   </p>
   <p class="toc-1-style">
    <a href="overview-chapter.html#overview-chapter_no" title="Innledning">
     Innledning
    </a>
   </p>
   <div id="divd0e52">
   </div>
   <p class="toc-1-style">
    <a href="general-information-chapter.html#general-information-chapter_no" title="Utformingshensyn for kj&oslash;p av papir">
     Utformingshensyn for kj&oslash;p av papir
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="paper-industry-overview-topic.html#paper-industry-overview_no" title="Oversikt over papirbransjen">
      Oversikt over papirbransjen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="design-factors-topic.html#design-factors_no" title="Papirutformingsfaktorer">
      Papirutformingsfaktorer
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="guidelines-for-selecting-and-using-paper.html#guidelines-for-selecting-and-using-paper_no" title="Retningslinjer for valg og bruk av papir">
     Retningslinjer for valg og bruk av papir
    </a>
   </p>
   <div id="divd0e603">
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e624" title="Papir">
      Papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycled-paper-guidelines-topic.html#d0e713" title="Resirkulert papir">
      Resirkulert papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tips-on-using-card-stock-topic.html#d0e786" title="Kartong">
      Kartong
     </a>
    </p>
    <p class="toc-2-style">
     <a href="envelope-guidelines-topic.html#d0e928" title="Konvolutter">
      Konvolutter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="labels.html#labels_no" title="Etiketter">
      Etiketter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-topic.html#troubleshooting_no" title="Feils&oslash;king">
      Feils&oslash;king
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-on-transparencies-topic.html#d0e1494" title="Transparenter">
      Transparenter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_no" title="Papir som ikke kan brukes">
      Papir som ikke kan brukes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_no" title="Bruke resirkulert papir">
      Bruke resirkulert papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="storing-paper-topic.html#storing-paper_no" title="Oppbevare papir">
      Oppbevare papir
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-specifications-chapter.html#printer-specifications-chapter_no" title="Skriverspesifikk papirst&oslash;tte">
     Skriverspesifikk papirst&oslash;tte
    </a>
   </p>
   <div id="divd0e1602">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-landscape-subgroup.html#d0e1605" title="Lexmark CS963, CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 skrivere og MFPer">
      Lexmark CS963, CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 skrivere og MFPer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-volunteer-topic.html#d0e11286" title="Lexmarks skrivere og MFP-er av f&oslash;lgende typer: C2335, CS531, CS632, CS639, CX532, CX635 og XC2335">
      Lexmarks skrivere og MFP-er av f&oslash;lgende typer: C2335, CS531, CS632, CS639, CX532, CX635 og XC2335
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-nile-topic.html#d0e12545" title="Lexmarks skrivere og MFP-er av f&oslash;lgende typer: M3350, MS531, MS631, MS632, MS639, MX532, MX632, XM3350">
      Lexmarks skrivere og MFP-er av f&oslash;lgende typer: M3350, MS531, MS631, MS632, MS639, MX532, MX632, XM3350
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-macau-topic.html#d0e13477" title="Lexmarks skrivere og MFP-er av f&oslash;lgende typer: C4342, C4352, CS730, CS735, CS737, CX730, CX735, CX737, XC4342 og XC4352">
      Lexmarks skrivere og MFP-er av f&oslash;lgende typer: C4342, C4352, CS730, CS735, CS737, CX730, CX735, CX737, XC4342 og XC4352
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-cobalt-topic.html#d0e14987" title="Lexmarks skrivere og MFP-er av f&oslash;lgende typer: B3340, B3442, M1342, MB3442, MS331, MS431, MS439, MX331, MX431, MX432, XM1342 og XM3142">
      Lexmarks skrivere og MFP-er av f&oslash;lgende typer: B3340, B3442, M1342, MB3442, MS331, MS431, MS439, MX331, MX431, MX432, XM1342 og XM3142
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-tenerife-topic.html#d0e15825" title="Lexmarks MFP-er av f&oslash;lgende typer: MX931, CX930, CX931, XC9325 og XC9335">
      Lexmarks MFP-er av f&oslash;lgende typer: MX931, CX930, CX931, XC9325 og XC9335
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-saipan-topic.html#d0e18977" title="Lexmarks skrivere og MFP-er av f&oslash;lgende typer: CS943, CX942, CX943, CX944, XC9445, XC9455, XC9465">
      Lexmarks skrivere og MFP-er av f&oslash;lgende typer: CS943, CX942, CX943, CX944, XC9445, XC9455, XC9465
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-nf-topic.html#d0e28821" title="Lexmarks skrivere og MFP-er av f&oslash;lgende typer: C2326, CS431, C3426, CS439, CX431, MC3426 og XC2326">
      Lexmarks skrivere og MFP-er av f&oslash;lgende typer: C2326, CS431, C3426, CS439, CX431, MC3426 og XC2326
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-lf-topic.html#d0e29540" title="Lexmarks skrivere og MFP-er av f&oslash;lgende typer: CS331, CX331, C3224, C3326, MC3224 og MC3326">
      Lexmarks skrivere og MFP-er av f&oslash;lgende typer: CS331, CX331, C3224, C3326, MC3224 og MC3326
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-gg-topic.html#d0e30260" title="Lexmarks B2236-skriver og MB2236-MFP">
      Lexmarks B2236-skriver og MB2236-MFP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-topic.html#d0e30988" title="Lexmarks skrivere og MFP-er av f&oslash;lgende typer: C2240, C2325, C2425, C2535, CS421, CS521, CS622, CX421, CX522, CX622, CX625, MC2325, MC2425, MC2535, MC2640, XC2235 og XC4240">
      Lexmarks skrivere og MFP-er av f&oslash;lgende typer: C2240, C2325, C2425, C2535, CS421, CS521, CS622, CX421, CX522, CX622, CX625, MC2325, MC2425, MC2535, MC2640, XC2235 og XC4240
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-ms725-topic.html#d0e32010" title="Lexmarks MS725-skriver og MX725-MFP">
      Lexmarks MS725-skriver og MX725-MFP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-ms820-topic.html#d0e33897" title="Lexmarks skrivere av f&oslash;lgende typer: B2865, M5255, M5270, MS821, MS822, MS823, MS825 og MS826">
      Lexmarks skrivere av f&oslash;lgende typer: B2865, M5255, M5270, MS821, MS822, MS823, MS825 og MS826
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-gdw-topic.html#d0e36242" title="Lexmarks MFP-er av f&oslash;lgende typer: MB2770, MX721, MX722, XM5365 og XM5370">
      Lexmarks MFP-er av f&oslash;lgende typer: MB2770, MX721, MX722, XM5365 og XM5370
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-wynn-topic.html#d0e37301" title="Lexmarks MFP-er av f&oslash;lgende typer: MX822, MX826, XM7355 og XM7370">
      Lexmarks MFP-er av f&oslash;lgende typer: MX822, MX826, XM7355 og XM7370
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-goldfinger-topic.html#d0e39658" title="Lexmarks skrivere av f&oslash;lgende typer: B2338, B2442, B2546, B2650, M1242, M1246, M3250, MS321, MS421, MS521, MS621, MS622">
      Lexmarks skrivere av f&oslash;lgende typer: B2338, B2442, B2546, B2650, M1242, M1246, M3250, MS321, MS421, MS521, MS621, MS622
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-skylm-topic.html#d0e40490" title="Lexmarks MFP-er av f&oslash;lgende typer: MB2338, MB2442, MX321, MX421 og XM1242">
      Lexmarks MFP-er av f&oslash;lgende typer: MB2338, MB2442, MX321, MX421 og XM1242
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-skyhmoon-topic.html#d0e41577" title="Lexmarks MFP-er av f&oslash;lgende typer: MB2546, MB2650, MX521, MX522, MX622, XM1242, XM1246 og XM3250">
      Lexmarks MFP-er av f&oslash;lgende typer: MB2546, MB2650, MX521, MX522, MX622, XM1242, XM1246 og XM3250
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-mahi-topic.html#d0e42664" title="Lexmarks skrivere og MFP-er av f&oslash;lgende typer: C9235, CS921, CS923, CS927, CX921, CX922, CX923, CX924, CX927, XC9225, XC9235, XC9245, XC9255 og XC9265">
      Lexmarks skrivere og MFP-er av f&oslash;lgende typer: C9235, CS921, CS923, CS927, CX921, CX922, CX923, CX924, CX927, XC9225, XC9235, XC9245, XC9255 og XC9265
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-sizes-ypp-topic.html#d0e45129" title="Lexmarks skrivere og MFP-er av f&oslash;lgende typer: C6160, CS820, CS827, CX820, CX825, CX827, CX860, XC6152, XC6153, XC8155, XC8160 og XC8163">
      Lexmarks skrivere og MFP-er av f&oslash;lgende typer: C6160, CS820, CS827, CX820, CX825, CX827, CX860, XC6152, XC6153, XC8155, XC8160 og XC8163
     </a>
    </p>
    <p class="toc-2-style">
     <a href="AC-chapter.html#d0e47968" title="Lexmarks skrivere og MFP-er av f&oslash;lgende typer: C4150, CS720, CS725, CS727, CS728, CX725, CX727, XC4140, XC4143, XC4150 og XC4153">
      Lexmarks skrivere og MFP-er av f&oslash;lgende typer: C4150, CS720, CS725, CS727, CS728, CX725, CX727, XC4140, XC4143, XC4150 og XC4153
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="glossary.html#glossary_no" title="Ordliste">
     Ordliste
    </a>
   </p>
   <div id="divd0e49006">
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue